const storageError = (): Error => new Error('Хранилище браузера не отвечает. Закройте остальные вкладки чата и перезапустите браузер. После перезапуска проверьте историю и очередь.');

export function openChatDatabase(milliseconds = 10_000): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('pm-chat', 2);
    let finished = false;
    const fail = (error: unknown): void => { if (finished) return; finished = true; clearTimeout(timer); reject(error); };
    const timer = setTimeout(() => fail(storageError()), milliseconds);
    request.onblocked = () => fail(new Error('Хранилище занято другой вкладкой. Закройте остальные вкладки чата и повторите. Очередь не удалена.'));
    request.onerror = () => fail(request.error ?? storageError());
    request.onupgradeneeded = () => {
      if (finished) { request.transaction?.abort(); return; }
      if (!request.result.objectStoreNames.contains('pending')) request.result.createObjectStore('pending', {keyPath:'client_message_id'});
      if (!request.result.objectStoreNames.contains('meta')) request.result.createObjectStore('meta', {keyPath:'key'});
    };
    request.onsuccess = () => {
      const db = request.result;
      if (finished) { db.close(); return; }
      finished = true; clearTimeout(timer);
      db.onversionchange = () => db.close();
      resolve(db);
    };
  });
}

export function completeStorageTransaction(tx: IDBTransaction, milliseconds = 10_000): Promise<void> {
  return new Promise((resolve, reject) => {
    let finished = false;
    const finish = (error?: unknown): void => {
      if (finished) return; finished = true; clearTimeout(timer);
      if (error) reject(error); else resolve();
    };
    const timer = setTimeout(() => {
      finish(storageError());
      try { tx.abort(); } catch { /* A transaction already committed cannot be aborted. */ }
    }, milliseconds);
    tx.oncomplete = () => finish();
    tx.onerror = () => finish(tx.error ?? storageError());
    tx.onabort = () => finish(tx.error ?? storageError());
  });
}

export function readStorageRequest<T>(request: IDBRequest<T>, milliseconds = 10_000): Promise<T> {
  return new Promise((resolve, reject) => {
    let finished = false;
    const finish = (error?: unknown): void => {
      if (finished) return; finished = true; clearTimeout(timer);
      if (error) reject(error); else resolve(request.result);
    };
    const timer = setTimeout(() => {
      finish(storageError());
      try { request.transaction?.abort(); } catch { /* This read may already have completed. */ }
    }, milliseconds);
    request.onsuccess = () => finish();
    request.onerror = () => finish(request.error ?? storageError());
  });
}
